import { createSlice } from "@reduxjs/toolkit";
import { sendVerificationMailAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const sendVerificationMailSlice = createSlice({
  name: "sendVerificationMail",
  initialState: data,
  reducers: {
    sendVerificationMailSlice(state) {
      state.isLoading = true;
    },
    sendVerificationMailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    sendVerificationMailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    sendVerificationMailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const sendEmailForVerification=(data:{
  email: string,
  link: string
  }) => async (dispatch: any) => {
  try {
    dispatch(sendVerificationMailAction.sendVerificationMailSlice());
    const response: any = await sendVerificationMailAPI(data);
    dispatch(sendVerificationMailAction.sendVerificationMailSliceSuccess(response))
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(sendVerificationMailAction.sendVerificationMailSliceFailure(e?.response?.data?.message));
    dispatch(sendVerificationMailAction.sendVerificationMailSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default sendVerificationMailSlice.reducer;
export const sendVerificationMailAction = sendVerificationMailSlice.actions;
